import { action } from 'satcheljs';
import { ComposeViewState } from 'owa-mail-compose-store';

export default action('loadSmimeComposeInfobars', (viewState: ComposeViewState) => ({ viewState }));
